/**
 * How `EvidenceDocumentTableComponent` handles a preview request.
 *
 * - `DIALOG` — the table opens the media viewer dialog itself (default).
 * - `EMIT` — the table only emits `previewRequested` and the parent renders the preview, e.g.
 *   inline in its own pane.
 */
export enum EvidenceTablePreviewMode {
    DIALOG = 'dialog',
    EMIT = 'emit',
}
